export const iconFontAwesomeCommunicationLanguage = (
	<i className="fa-solid fa-language"></i>
);
